export default "__VITE_ASSET__BnFnMXTX__"